import { Amplify } from 'aws-amplify';

const redirect = `${window.location.origin}/auth/callback`;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [redirect],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: 'code',
        },
      },
    },
  },
});

/** The Cognito identity-provider name for Embrace's Entra federation. */
export const OIDC_PROVIDER =
  (import.meta.env.VITE_OIDC_PROVIDER as string) ?? 'Entra';
